import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-readers"
}, "Readers", -1);
const _hoisted_3 = {
  class: "col"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-workers"
}, "Workers", -1);
const _hoisted_5 = {
  class: "d-flex"
};
const _hoisted_6 = {
  class: "align-self-stretch flex-fill w-100 text-center"
};
const _hoisted_7 = ["min", "max"];
const _hoisted_8 = {
  id: "input-workers-list"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  label: "0"
}, null, -1);
const _hoisted_10 = ["value", "label"];
const _hoisted_11 = {
  class: "order-first"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-arrow-left"
}, null, -1);
const _hoisted_13 = {
  class: "order-last"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-arrow-right"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-camera"
}, "Camera", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("legend", null, "Video", -1);
const _hoisted_17 = {
  class: "row"
};
const _hoisted_18 = {
  class: "col"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label"
}, "Ratio", -1);
const _hoisted_20 = {
  class: "col"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-width"
}, "width", -1);
const _hoisted_22 = ["min", "max"];
const _hoisted_23 = {
  class: "col"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "input-height"
}, "height", -1);
const _hoisted_25 = ["min", "max"];
const _hoisted_26 = {
  class: "row"
};
const _hoisted_27 = {
  class: "col"
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("legend", null, "Options", -1);
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn text-light",
  "data-bs-dismiss": "offcanvas"
}, "Cancel", -1);
import { reactive } from "vue";
import { useQuaggaConfigStore, QUAGGA_DEFAULT_CONFIGS, USER_MEDIA } from "@/store/quagga-config";

// store

const __default__ = {
  name: "o-settings"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const quaggaConfigStore = useQuaggaConfigStore();

    // data
    const model = reactive({
      deviceId: "",
      readers: quaggaConfigStore.readers,
      numOfWorkers: quaggaConfigStore.numOfWorkers,
      width: {
        min: quaggaConfigStore.width.min,
        ideal: quaggaConfigStore.width.ideal,
        max: quaggaConfigStore.width.max
      },
      height: {
        min: quaggaConfigStore.height.min,
        ideal: quaggaConfigStore.height.ideal,
        max: quaggaConfigStore.height.max
      },
      singleChannel: quaggaConfigStore.singleChannel
    });
    const OPTIONS = (() => {
      const devices = USER_MEDIA.devices();
      return {
        READERS: QUAGGA_DEFAULT_CONFIGS.readers("values").map(value => ({
          text: value,
          value: value
        })),
        WORKERS_RANGE: QUAGGA_DEFAULT_CONFIGS.numOfWorkers("range"),
        DEVICES: devices,
        CAMERAS: USER_MEDIA.cameras().map(device => ({
          text: device.label,
          value: device.deviceId
        })),
        RATIO: [{
          text: "21x9",
          value: 9 / 21
        }, {
          text: "16x9",
          value: 9 / 16,
          default: true
        }, {
          text: "4x3",
          value: 3 / 4
        }, {
          text: "1x1",
          value: 1
        }].map(ratio => ({
          text: ratio.text,
          value: ratio.value,
          default: ratio.default || false
        })),
        WIDTH: {
          min: QUAGGA_DEFAULT_CONFIGS.width("default").min,
          max: QUAGGA_DEFAULT_CONFIGS.width("default").max
        },
        HEIGHT: {
          min: QUAGGA_DEFAULT_CONFIGS.height("default").min,
          max: QUAGGA_DEFAULT_CONFIGS.height("default").max
        }
      };
    })();
    const material = reactive({
      ratio: String(OPTIONS.RATIO.filter(opt => opt.default === true)[0].value)
    });

    // method
    /**
     * @param {Event} event
     */
    const _defaultEventCancel = event => {
      if (event) event.preventDefault();
    };
    const _forceRange = ({
      width,
      height
    }) => {
      if (width < OPTIONS.WIDTH.min) {
        width = OPTIONS.WIDTH.min;
      } else if (OPTIONS.WIDTH.max < width) {
        width = OPTIONS.WIDTH.max;
      }
      if (height < OPTIONS.HEIGHT.min) {
        height = OPTIONS.HEIGHT.min;
      } else if (OPTIONS.HEIGHT.max < height) {
        height = OPTIONS.HEIGHT.max;
      }
      return {
        width,
        height
      };
    };
    const emitInputRatio = value => {
      let height = Math.floor(Number.parseFloat(model.width.ideal) * Number.parseFloat(value));
      const box = _forceRange({
        width: value,
        height
      });
      model.width.ideal = box.width;
      model.height.ideal = box.height;
    };
    const doInputWidth = event => {
      let value = event.target.value;
      let height = Math.floor(Number.parseFloat(value) * Number.parseFloat(material.ratio));
      const box = _forceRange({
        width: value,
        height
      });
      model.width.ideal = box.width;
      model.height.ideal = box.height;
    };
    const doInputHeight = event => {
      let value = event.target.value;
      let width = Math.floor(Number.parseFloat(value) / Number.parseFloat(material.ratio));
      const box = _forceRange({
        width,
        height: value
      });
      model.width.ideal = box.width;
      model.height.ideal = box.height;
    };
    const doClickFitSize = () => {
      const body = document.body;
      const rect = body.getBoundingClientRect();
      const box = _forceRange({
        width: rect.width,
        height: rect.height
      });
      model.width.ideal = box.width;
      model.height.ideal = box.height;
    };
    const doClickOk = event => {
      _defaultEventCancel(event);
      Object.entries(model).forEach(([key, value]) => {
        quaggaConfigStore.setConfig(key, value);
      });
      quaggaConfigStore.setEvents("update");
    };
    return (_ctx, _cache) => {
      const _component_b_form_checkbox_group = _resolveComponent("b-form-checkbox-group");
      const _component_b_button = _resolveComponent("b-button");
      const _component_b_form_select = _resolveComponent("b-form-select");
      const _component_b_form_select_option = _resolveComponent("b-form-select-option");
      const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("form", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_b_form_checkbox_group, {
        id: "input-readers",
        modelValue: model.readers,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => model.readers = $event),
        options: _unref(OPTIONS).READERS
      }, null, 8, ["modelValue", "options"])])]), _createElementVNode("div", null, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(`${model.numOfWorkers}/${_unref(OPTIONS).WORKERS_RANGE.max}`), 1), _withDirectives(_createElementVNode("input", {
        class: "w-100 text-light",
        type: "range",
        id: "input-workers",
        list: "input-workers-list",
        min: _unref(OPTIONS).WORKERS_RANGE.min,
        max: _unref(OPTIONS).WORKERS_RANGE.max,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => model.numOfWorkers = $event)
      }, null, 8, _hoisted_7), [[_vModelText, model.numOfWorkers]]), _createElementVNode("datalist", _hoisted_8, [_hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OPTIONS).WORKERS_RANGE.max, n => {
        return _openBlock(), _createElementBlock("option", {
          key: n,
          value: n,
          label: n
        }, null, 8, _hoisted_10);
      }), 128))])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_b_button, {
        variant: "primary",
        onClick: _cache[2] || (_cache[2] = $event => _unref(OPTIONS).WORKERS_RANGE.min < model.numOfWorkers ? --model.numOfWorkers : false)
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_b_button, {
        variant: "primary",
        onClick: _cache[3] || (_cache[3] = $event => model.numOfWorkers < _unref(OPTIONS).WORKERS_RANGE.max ? ++model.numOfWorkers : false)
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      })])])]), _createElementVNode("div", null, [_hoisted_15, _createVNode(_component_b_form_select, {
        id: "input-camera",
        modelValue: model.deviceId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => model.deviceId = $event),
        options: _unref(OPTIONS).CAMERAS
      }, null, 8, ["modelValue", "options"])]), _createElementVNode("fieldset", null, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_b_form_select, {
        id: "input-ratio",
        modelValue: material.ratio,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => material.ratio = $event),
        onInput: emitInputRatio
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OPTIONS).RATIO, (opt, idx) => {
          return _openBlock(), _createBlock(_component_b_form_select_option, {
            key: idx,
            value: String(opt.value)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.text), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _withDirectives(_createElementVNode("input", {
        id: "input-width",
        class: "form-control",
        type: "number",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => model.width.ideal = $event),
        min: model.width.min,
        max: model.width.max,
        step: "10",
        onInput: doInputWidth
      }, null, 40, _hoisted_22), [[_vModelText, model.width.ideal]])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _withDirectives(_createElementVNode("input", {
        id: "input-height",
        class: "form-control",
        type: "number",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => model.height.ideal = $event),
        number: "",
        min: model.height.min,
        max: model.height.max,
        step: "10",
        onInput: doInputHeight
      }, null, 40, _hoisted_25), [[_vModelText, model.height.ideal]])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_b_button, {
        onClick: doClickFitSize
      }, {
        default: _withCtx(() => [_createTextVNode("fix body")]),
        _: 1
      })])])]), _createElementVNode("fieldset", null, [_hoisted_28, _createElementVNode("div", null, [_createVNode(_component_b_form_checkbox, {
        checked: model.singleChannel,
        modelValue: model.singleChannel,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => model.singleChannel = $event)
      }, {
        default: _withCtx(() => [_createTextVNode(" SingleChannel ")]),
        _: 1
      }, 8, ["checked", "modelValue"])])])]), _createElementVNode("section", {
        class: "modal-footer"
      }, [_createElementVNode("button", {
        class: "btn btn-success",
        "data-bs-dismiss": "offcanvas",
        onClick: doClickOk
      }, " OK "), _hoisted_29])], 64);
    };
  }
});